var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCompass = function SvgCompass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.616 12.616a.87.87 0 1 0-1.23-1.232.87.87 0 0 0 1.23 1.232zm3.138-5.37a.717.717 0 0 0-.244.042L9.89 9.315a.938.938 0 0 0-.573.573L7.289 15.51c-.205.569.375 1.244.958 1.244a.717.717 0 0 0 .243-.042l5.622-2.027a.938.938 0 0 0 .573-.574l2.027-5.621c.205-.569-.375-1.244-.958-1.244zm-2.129 6.38-5.084 1.832 1.833-5.084L15.46 8.54l-1.834 5.084zM12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9 9 0 0 0 9-9 9 9 0 0 0-9-9zm0 16.839c-4.322 0-7.839-3.517-7.839-7.839 0-4.322 3.517-7.839 7.839-7.839 4.322 0 7.839 3.517 7.839 7.839 0 4.322-3.517 7.839-7.839 7.839z",
    fill: "currentColor"
  })));
};

export default SvgCompass;